(function () {
  const params = new URLSearchParams(window.location.search);
  const genderFilter = params.get('filter.p.m.custom.gender');
  const currentSort = params.get('sort_by') || '';

  // If user applied a gender filter or explicit sort, don't interfere
  if (genderFilter || (currentSort && currentSort !== 'manual')) return;

  // Read ?gender=men or ?gender=womens from the nav link
  const primaryGender = (params.get('gender') || 'men').toLowerCase();

  function sortGrid() {
    const grid = document.getElementById('ProductsList');
    if (!grid) return;

    const columns = Array.from(grid.querySelectorAll('.product-column[data-gender]'));
    if (!columns.length) return;

    const primary   = columns.filter(el => el.dataset.gender === primaryGender);
    const secondary = columns.filter(el => el.dataset.gender !== primaryGender && el.dataset.gender !== '');
    const ungrouped = columns.filter(el => el.dataset.gender === '');

    const ordered = [...primary, ...secondary, ...ungrouped];
    // Already in order: do nothing (re-appending would re-trigger the observer below in an endless loop).
    if (ordered.every((el, i) => columns[i] === el)) return;
    ordered.forEach(el => grid.appendChild(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortGrid);
  } else {
    sortGrid();
  }

  document.addEventListener('shopify:section:load', sortGrid);
  document.addEventListener('facets:updated', sortGrid);

  const observer = new MutationObserver(function (mutations) {
    const relevant = mutations.some(m =>
      Array.from(m.addedNodes).some(n => n.nodeType === 1 && n.classList?.contains('product-column'))
    );
    if (relevant) sortGrid();
  });

  function attachObserver() {
    const grid = document.getElementById('ProductsList');
    if (grid) observer.observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }
})();